

$(".navbar-toggler").click(function () {

    $(".navbar-toggler").toggleClass("showtoggle");
    $(".header_sec").toggleClass("showhead");
});



$(".closed").click(function () {

    $(".navbar-collapse").removeClass("show");

});


$(".jobsbtn span").click(function () {
    $(".topjobbox").slideToggle("slow");
});


$(".searh_bx a").click(function () {
    $(".topjobbox").slideToggle("slow");
});


$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".header_sec").addClass("fixed");

    } else {
        $(".header_sec").removeClass("fixed");
    }

});


$(document).ready(function () {
    var owl = $('.logoLeft .owl-carousel');
    owl.owlCarousel({
        dots: false,
        loop: true,
        autoplayHoverPause: true,
        navText: ["<i class='fa-solid fa-angle-left'></i>", "<i class='fa-solid fa-angle-right'></i>"],
        autoplay: true,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 2,
                dots: true,
            },
            500: {
                items: 2,
                dots: true,
            },
            576: {
                items: 3,
                dots: true,
            },
            768: {
                items: 4,
                slideTransition: "linear",
                autoplayTimeout: 0,
                smartSpeed: 3000,
                fluidSpeed: true,
                autoplayTimeout: 3000,
                autoplayHoverPause: false,
                responsiveClass: true,
            },
            1300: {
                items: 5,
                slideTransition: "linear",
                autoplayTimeout: 0,
                smartSpeed: 3000,
                fluidSpeed: true,
                autoplayTimeout: 3000,
                autoplayHoverPause: false,
                responsiveClass: true,
            },
            1400: {
                items: 6,
                slideTransition: "linear",
                autoplayTimeout: 0,
                smartSpeed: 3000,
                fluidSpeed: true,
                autoplayTimeout: 3000,
                responsiveClass: true,
            },
            1400: {
                items: 7,
                slideTransition: "linear",
                autoplayTimeout: 0,
                smartSpeed: 3000,
                fluidSpeed: true,
                autoplayTimeout: 3000,
                responsiveClass: true,
            }
        }
    });
});

$(document).ready(function () {
    var owl = $('.logoRight .owl-carousel');
    owl.owlCarousel({
        rtl: true, // 🔥 Important for Right → Left
        dots: false,
        loop: true,
        navText: ["<i class='fa-solid fa-angle-left'></i>", "<i class='fa-solid fa-angle-right'></i>"],
        autoplay: true,
        slideTransition: "linear",
        autoplayTimeout: 0,
        smartSpeed: 3000,
        fluidSpeed: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsiveClass: true,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            500: {
                items: 2
            },
            576: {
                items: 3
            },
            768: {
                items: 4
            },
            1300: {
                items: 5
            },
            1400: {
                items: 6
            },
            1400: {
                items: 7
            }
        }
    });
});



$(document).ready(function () {

    $(".tab-list a").click(function (event) {

        event.preventDefault();

        // Tab menu active
        $(this).parent().addClass("current");
        $(this).parent().siblings().removeClass("current");

        // Target tab content
        var tab = $(this).attr("href");

        // Hide all content + remove active
        $(".tab-contRow").hide().removeClass("active");

        // Show selected content + add active
        $(tab).fadeIn().addClass("active");

    });

});




$(document).ready(function () {
    var owl = $('.job-caro.owl-carousel');
    owl.owlCarousel({
        dots: true,
        margin: 15,
        navText: ["<i class='fa-solid fa-angle-left'></i>", "<i class='fa-solid fa-angle-right'></i>"],
        autoplay: true,
        nav: false,
        dotsEach: false,
        stagePadding: 0,
        loop: true,
        responsive: {
            0: {
                items: 1
            },
            500: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 2
            },
            1300: {
                items: 3,
                margin: 20,
            },
            1400: {
                items: 3,
                margin: 20,
            },
            1400: {
                items: 3,
                margin: 20,
            }
        }
    });
});


$(document).ready(function () {

    $(".acc-head").click(function () {

        // If already active → do nothing
        if ($(this).hasClass("active")) {
            return;
        }

        // Remove all active classes
        $(".acc-head").removeClass("active");
        $(".acc-item").removeClass("active");
        $(".acc-body").slideUp();

        // Add active to current
        $(this).addClass("active");
        $(this).closest(".acc-item").addClass("active");
        $(this).next(".acc-body").slideDown();

    });

});


$(document).ready(function () {
    var owl = $('.testemoni-caro.owl-carousel');
    owl.owlCarousel({
        dots: true,
        margin: 15,
        navText: ["<i class='fa-solid fa-angle-left'></i>", "<i class='fa-solid fa-angle-right'></i>"],
        autoplay: false,
        nav: false,
        dotsEach: false,
        stagePadding: 0,
        loop: true,
        responsive: {
            0: {
                items: 1
            },
            500: {
                items: 1
            },
            576: {
                items: 1
            },
            768: {
                items: 1
            },
            1300: {
                items: 3,
                margin: 20,
            },
            1400: {
                items: 3,
                margin: 20,
            },
            1400: {
                items: 3,
                margin: 20,
            }
        }
    });
});



document.addEventListener("DOMContentLoaded", function () {

    //const levels = document.querySelectorAll(".levels");
    //const indicator = document.querySelector(".level-indicator");

    //function activateLevel(index) {
    //    levels.forEach(l => l.classList.remove("active"));
    //    levels[index].classList.add("active");
    //    indicator.style.left = (100 / levels.length) * index + "%";
    //}

    //// 👉 Default Active = Intermediate
    //activateLevel(1);

    //levels.forEach((level, index) => {
    //    level.addEventListener("click", function () {
    //        activateLevel(index);
    //    });
    //});

});





























